var exports = {
  "S": "xb99ab02a--8be29f--image",
};

module.exports = exports;
